import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonsDashboardProps } from "../../../Pages/VideoLessonsDashboard/subject/IVideoLessonDashboard";

// 👇 Combine the interfaces to represent a full video Subject item
export type IVideoSubject = VideoLessonsDashboardProps;

export const ListVideoSubjectSlice = createSlice({
  name: "ListVideoSubjectSlice",
  initialState: {} as IReduxState<IVideoSubject[]>,
  reducers: {
    listVideoSubject: (state) => {
      state.isLoading = true;
    },

    successListVideoSubject: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListVideoSubject: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  listVideoSubject,
  successListVideoSubject,
  failureListVideoSubject,
} = ListVideoSubjectSlice.actions;

export default ListVideoSubjectSlice.reducer;
